(ns dre.pages.admin.survey.views
  (:require
   [dre.components.icon :refer [fa-icon]]
   [dre.pages.admin.survey.events :as survey]
   [dre.pages.admin.views :refer [nav-tabs]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def component-name :admin-survey)

(defn view
  []
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :nav)}
    [nav-tabs]]
   [:div
    {:class (bem/be component-name :content)}
    [:div "NPS Surveys:"]
    [:button.button.button--brand
     {:on-click #(rf/dispatch [::survey/download-csv])}
     [fa-icon :download]
     "Results"]]])
